import { api } from 'app/utils/api/helpers'

export const getBackgroundCheck = (applicationGUID, applicantGUID) => {
  return api.get(
    `sm/applications/${applicationGUID}/applicant/${applicantGUID}/backgroundcheck`,
  )
}
